export default {
  INIT: 'REFUND/INIT',
  UPDATE_DATA: 'REFUND/UPDATE_DATA',
  UPDATE_META: 'REFUND/UPDATE_META',
  UPDATE_PARAMS: 'REFUND/UPDATE_PARAMS',
}
